import axios from "axios";
import httpTools from "./httpTools";
import Q from "q";

const GetProducts = (() => {
  let baseUrl = httpTools.envUrls();
  let subApiUrl = httpTools.subApiUrl();
  return {
    init: ({ country, language, catalogType, catalogName}) => {
      const language_str = language + "-" + country;
      let defer = Q.defer();
      axios.get(
        `${baseUrl}/catalogs/${catalogName}%20${catalogType}?expand=catalogSlides.item`,
        {
          headers: {
            "Accept-Language": language_str
          }
        }
      )
      .then(res => {
        defer.resolve(res);
      })
      .catch(error => {
        console.error(error);
        defer.reject(error);
      });
      return defer.promise;
    },

    productQuotes: ({ country, customerType, itemCodes }) => {
      let defer = Q.defer();
      let types = {"FP":"Associate", "PC":"Customer"};
      const pricingPostData = {
        order: {
          customer: {
            href: `${subApiUrl}/customers?type=${types[customerType]}`
          },
          shipToAddress: { country: country }
        },
        vary: {
          lines: {
            items: [
              {
                item: {
                  href: `${subApiUrl}/items?id.unicity=${itemCodes}`
                }
              }
            ]
          }
        }
      };

      const pricingHeaders = {
        "Content-Type": "application/json"
      };
      axios.post(
        `${baseUrl}/quotes?&expand=item`,
        pricingPostData,
        {
          headers: pricingHeaders
        }
      )
      .then(res => {
        defer.resolve(res);
      })
      .catch(error => {
        console.error(error);
        defer.reject(error);
      });
      return defer.promise;
    }
  };
})();

//if we are in the AR pipeline
/*  if (Catalog.getType() !== 'Shopping') {
      //and we don't have language or country
      if (!language && !country) {
          //if we have locale set in $stateParams
          if ($stateParams.locale) {
              locale = $stateParams.locale;
              locale = locale.split("-");
              language = locale[0];
              country = locale[1];
          } else {
              //else default to en-US
              language = 'en';
              country = 'US';
          }

      }

  }*/

/*var checkCatalogName = function(catalogName) {
    var order = OrderInfo.get();
    var nfrStatus = nfr.getNfrStatus();
    var name;
    if (order.shipping.method && order.shipping.method.type === 'WillCall') {
        name = order.shipping.method.location.split(" ");
        return name[1];
    } else if (nfrStatus) {
        catalogName = catalogName + "%20NFR";
        return catalogName;
    } else {
        return catalogName;
    }

};*/

/*

 if (MarketExceptions.isMultiCatalog() || MarketExceptions.hasNfr()) {
                catalogName = checkCatalogName(catalogName);
            }
*/

/*if (country === "PR") {
               //reset country to US for language_str
               country = 'US';
           }*/

export default GetProducts;



// WEBPACK FOOTER //
// ./src/services/http/getProducts.js